export default __webpack_public_path__ + "static/media/title-billingIcon.7cce88f0.svg";